import { useContext } from 'react';
import { TaskContext } from './TaskContext';
import { TaskContextType } from './TaskTypes';

/**
 * Custom hook to use the Task context
 * @returns {TaskContextType} Task state and methods
 * @throws {Error} If used outside of TaskProvider
 */
export const useTask = (): TaskContextType => {
  const context = useContext(TaskContext);
  
  if (context === undefined) {
    throw new Error('useTask must be used within a TaskProvider');
  }
  
  return context;
}; 